import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import React, { useState } from "react";

import type { LogEntryId } from "@apis/calorie-grid/models";

import { useQueries } from "../../../shared/hooks/useQueries.ts";

import { LogEntryChip } from "./LogEntryChip.tsx";
import { ShapePicker } from "./ShapePicker.tsx";

export const PlacementQueue: FC = () => {
  const [selectedId, setSelectedId] = useState<LogEntryId | null>(null);

  const { getLogEntriesQueryOptions } = useQueries();
  const logEntriesQueryResult = useQuery(getLogEntriesQueryOptions());
  const logEntries = logEntriesQueryResult.data ?? [];
  const pending = logEntries.filter(e => e.status === "pending");

  const active = pending.find(e => e.id === selectedId) ?? pending[0];

  return (
    <div className="flex shrink-0 flex-col gap-2 border-b bg-card px-3.5 py-2.5">
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold tracking-[0.04em] text-muted-foreground uppercase">
          Now logging
        </span>
        {pending.length > 0 && (
          <span className="text-[11px] text-muted-foreground">
            {pending.length} in queue
          </span>
        )}
      </div>
      {active ? (
        <ShapePicker key={active.id} logEntry={active} />
      ) : (
        <p className="py-1.5 text-[13px] text-muted-foreground">
          Nothing in the queue — add a purchase
        </p>
      )}
      {pending.length > 1 && (
        <div className="flex gap-2 overflow-x-auto">
          {pending.map(logEntry => (
            <LogEntryChip
              active={logEntry.id === active?.id}
              key={logEntry.id}
              logEntry={logEntry}
              onSelect={setSelectedId}
            />
          ))}
        </div>
      )}
    </div>
  );
};
